import { Permission } from './permission';

export class Policy {
  PolicyId: string;
  PolicyName: string;
  Permissions: Permission[] = [];
  Order: number;
}
